// Heritage Dahlias, central feature flags.
// Flip to true to re-enable across the site. Per-customer admin toggle
// (`vip_box_enabled` on the customer account) still applies on top of this.
export const VIP_BOX_FEATURE_ENABLED = true;

// Heritage Garden, Breeders' Bed.
// The submission form (/breeders-garden) is always live so breeders can
// apply year-round. The PUBLIC display page (/heritage-garden) is gated
// here, flip to true once you have the first accepted seedlings published.
export const HERITAGE_GARDEN_PUBLIC_DISPLAY = false;
